import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Resolve,
} from '@angular/router';
import {
  Inject,
  Injectable,
  OnDestroy,
  Optional,
  PLATFORM_ID,
} from '@angular/core';
import { CharterBuyflowSessionService } from '../../../../core/services/charter-buyflow-session.service';
import { VesselDAO } from '../../../../core/services/dao/vesselDAO';
import { WaterBodyDAO } from '../../../../core/services/dao/waterBodyDAO';
import { VanityUrlService } from '../../../../core/services/vanity-url.service';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs/Rx';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { ApiHelper } from '../../../../core/services/apiHelper';
import { environment } from '../../../../environments/environment';

const CHARTER_BUYFLOW_WATER_BODIES_KEY = makeStateKey(
  'charterBuyflowWaterBodies',
);

@Injectable()
export class CharterBuyflowVesselsResolve
  implements Resolve<any>, ContainsSubscriptions, OnDestroy
{
  public buyflowWaterBodyResolveData: any;
  subs: Subscription[] = [];

  constructor(
    private charterBuyFlowSession: CharterBuyflowSessionService,
    private vesselDAO: VesselDAO,
    private waterBodyDAO: WaterBodyDAO,
    private vanityUrlService: VanityUrlService,
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: any,
    private state: TransferState,
    private route: ActivatedRoute,
    private apiHelper: ApiHelper,
  ) {
    this.apiHelper.setEnvironment(environment.envName);
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  resolve(route: ActivatedRouteSnapshot) {
    this.buyflowWaterBodyResolveData = this.state.get(
      CHARTER_BUYFLOW_WATER_BODIES_KEY,
      null,
    );

    return new Observable((observer) => {
      if (!this.buyflowWaterBodyResolveData) {
        const waterBodySub = this.getLoadActiveMarkets$().subscribe(
          (response) => {
            this.buyflowWaterBodyResolveData = response;
            this.state.set(
              CHARTER_BUYFLOW_WATER_BODIES_KEY,
              this.buyflowWaterBodyResolveData,
            );
            observer.next(this.buyflowWaterBodyResolveData);
            observer.complete();
          },
        );
        this.subs.push(waterBodySub);
      } else {
        observer.next(this.buyflowWaterBodyResolveData);
        observer.complete();
      }
    });
  }

  getLoadActiveMarkets$(): Observable<WaterBody[]> {
    return this.waterBodyDAO.loadActiveMarkets();
  }
}
